import React from 'react';
import {useNavigate} from 'react-router-dom';


import {iconConstants} from '../../Icon';

import IconLink from '../IconLink';


function BackLink({}) {

    const navigate = useNavigate();

    return (
        <IconLink
            iconType={iconConstants.ICON_ARROW_LEFT_2}
            labelI18n={'global.back'}
            onClick={() => navigate(-1)}
        />
    );
}


BackLink.propTypes = {};

BackLink.defaultProps = {};


export default BackLink;
